/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
import Swiper from 'swiper/js/swiper';
import fullpage from 'fullpage.js';
import SmoothScroll from 'smooth-scroll';
import '~/sass/pages/feature.scss';

const { $ } = window;

let $videoSrc = null;
let scroll = null;
let swiper = null;
let swiperB = null;
let swiperC = null;
let swiperD = null;
let myFullpage = null;

/*  封裝內裝輪播 */
function inside2() {
  swiperB = new Swiper('#inside-2', {
    /*     loop: true, */
    navigation: {
      nextEl: '.side-button-next.fix.inside-2',
      prevEl: '.side-button-prev.fix.inside-2',
    },
  });
  const windowSize = $(window).width();
  if (windowSize < 479) {
    swiperB.destroy(true);
  }
}
/*  封裝內裝輪播 */
function inside3() {
  swiperC = new Swiper('#inside-3', {
    navigation: {
      nextEl: '.side-button-next.fix.inside-3',
      prevEl: '.side-button-prev.fix.inside-3',
    },
  });
  const windowSize = $(window).width();
  if (windowSize < 479) {
    swiperC.destroy(true);
  }
}

$(document).ready(() => {
  // 額外增加
  $('body').addClass('unit-feature');

  scroll = new SmoothScroll('a[href*="#"]', {
    offset: 60,
  });
  /* yotube視窗 */
  $('.play-go').click(function () {
    $videoSrc = $(this).attr('data-src');
    $('body').addClass('active');
    $('#show-video').addClass('active');
    $('#video').attr('src', `${$videoSrc}?autoplay=1&amp;modestbranding=1&amp;showinfo=0`);
  });
  $('.v-close').on('click', function () {
    $('body').removeClass('active');
    $(this).closest('.modal-mask').removeClass('active');
    $('#video').attr('src', '');
  });

  /* 側彈窗 */
  $('.side-close').on('click', function () {
    $('body').removeClass('active');
    $(this).closest('.side-mask').removeClass('active');
  });
  $('.side-mask').on('click', function () {
    $(this).removeClass('active');
    $('body').removeClass('active');
  });
  $('.side-box').on('click', (event) => {
    event.stopPropagation();
  });

  /* 外觀 */
  swiper = new Swiper('.looks', {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.looks-pagination',
      clickable: true,
    },
  });
  /* 動力視窗加輪播 */
  $('.feature-power-img a').on('click', function () {
    $('#power-side').addClass('active');
    const PG = parseInt($(this).attr('data-pg'), 10);
    setTimeout(() => {
      const swiperP = new Swiper('#power-pic', {
        loop: true,
        speed: 300,
        navigation: {
          nextEl: '.side-button-next.power',
          prevEl: '.side-button-prev.power',
        },
      });
      swiperP.slideTo(PG, 10, true);
    }, 50);
  });
  /* 空間視窗加輪播 */
  $('a.space,a.outfit,a.color').on('click', function () {
    $('#space-side').addClass('active');
    const PG = $(this).attr('data-pg');
    setTimeout(() => {
      const swiperS = new Swiper('#space-pic', {
        loop: true,
        speed: 300,
        navigation: {
          nextEl: '.side-button-next.space',
          prevEl: '.side-button-prev.space',
        },
      });
      swiperS.slideTo(PG, 10, true);
    }, 50);
  });
  /* 外觀視窗加輪播 */
  $('.looks-car a').on('click', function () {
    $('#looks').addClass('active');
    const PG = $(this).attr('data-pg');
    setTimeout(() => {
      const swiperA = new Swiper('#side-pic', {
        loop: true,
        loopAdditionalSlides: 0,
        speed: 300,
        navigation: {
          nextEl: '.side-button-next.look',
          prevEl: '.side-button-prev.look',
        },
      });
      swiperA.slideTo(PG, 10, true);
    }, 50);
  });
  /* GALLERY視窗加輪播 */
  $('a.gallery-img').on('click', function () {
    $('#gallery-side').addClass('active');
    const PG = parseInt($(this).attr('data-pg'), 10);
    setTimeout(() => {
      const swiperP = new Swiper('#gallery-pic', {
        loop: true,
        speed: 300,
        navigation: {
          nextEl: '.side-button-next.gallery',
          prevEl: '.side-button-prev.gallery',
        },
      });
      swiperP.slideTo(PG, 10, true);
    }, 50);
  });
  /* eTNGA頁籤 */
  $('.etnga-tab a').on('click', function () {
    const ID = $(this).attr('data-id');
    $('.etnga-tab a,.etnga-tab-box').removeClass('active');
    $(this).addClass('active');
    $(`#${ID}`).addClass('active');
  });
  /* 充電頁籤  */
  $('.charge-tab a').on('click', function () {
    const ID = $(this).attr('data-id');
    $('.charge-tab a,.charge-tab-box').removeClass('active');
    $(this).addClass('active');
    $(`#${ID}`).addClass('active');
  });
  /* 動力電池頁籤  */
  $('.power-tab a').on('click', function () {
    const ID = $(this).attr('data-id');
    $('.power-tab a,.power-tab-box').removeClass('active');
    $(this).addClass('active');
    $(`#${ID}`).addClass('active');
  });
  /* 內裝 */
  $('.nav-tabs a').on('click', function () {
    const ID = $(this).attr('data-id');
    const tbID = $(this).closest('.nav-tabs').attr('id');
    $(`#${tbID}.nav-tabs a`).removeClass('active');
    $(`.${tbID}`).find('.feature-tab-panel').removeClass('active');
    $(this).addClass('active');
    $(`#${ID}`).addClass('active');
    $('.inside-open-more a').removeClass('active');
    inside2();
    inside3();
  });

  /* 手機版展開更多 */
  $('.inside-open-more a').on('click', function () {
    $(this).toggleClass('active');
    $('.inside-mobile').slideToggle(300);
  });
  /*  主被動安全icon頁籤 */
  $('.icon-tab a').on('click', function () {
    const ID = $(this).attr('data-id');
    const tbID = $(this).closest('.icon-tab').attr('id');
    $(`#${tbID}.icon-tab a`).removeClass('active');
    $(`.${tbID}`).removeClass('active');
    $(this).addClass('active');
    $(`#${ID}`).addClass('active');
  });

  /* 主動安全/被動安全頁籤  */
  $('.nav-tabs.pc a').on('click', function () {
    const Val = $(this).text();
    const ID = $(this).attr('data-id');
    const tbID = $(this).closest('.nav-tabs').attr('id');
    $(`#${tbID}.nav-tabs a`).removeClass('active');
    $(`.${tbID}`).find('.feature-tab-panel').removeClass('active');
    $(this).addClass('active');
    $(`#${ID}`).addClass('active');
    $(this).closest('.nav-tabs').closest('.drop-btn').find('.drop-select')
      .text(Val);
    $(this).closest('.nav-tabs').removeClass('active');
    $(this).closest('.nav-tabs').closest('.drop-btn').find('.drop-select')
      .removeClass('active');
  });
  /* 被動安全頁籤active 內容 */
  $('#feature-safety-2 .nav-tabs.pc a').on('click', function () {
    const Val = $(this).text();
    const ID = $(this).attr('data-id');
    const tbID = $(this).closest('.nav-tabs').attr('id');
    $(`#feature-safety-2 .${tbID}`).find('.icon-tab-box').removeClass('active');
    $(`#${ID} .icon-tab-box`).addClass('active');
    $(`#feature-safety-2 .${tbID}`).find('img').hide();
    $(`#${ID} img`).show();
  });
  /*  主被動安全dropbox */
  $('.drop-select').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.nav-tabs.pc').toggleClass('active');
  });
  /*  主動安全 icon scrollbar */
  // icon list fix scroll
  document.querySelectorAll('.scroll-icon-menu ul').forEach((element) => {
    const oWidth = element.offsetWidth;
    const sWidth = element.scrollWidth;
    const sLeft = element.scrollLeft;
    if (oWidth - sWidth !== 0) {
      console.log(sLeft);
      $(element).next().addClass('show');
    }
  });
  $('#feature-safety-1 .nav-tabs.pc a').on('click', function () {
    const ID = $(this).attr('data-id');
    const ul = $(`#feature-safety-1 #${ID} .icon-tab.icon-list`);
    if (ul.length === 0) {
      return;
    }
    const ele = ul.get(0);
    const oWidth = ele.offsetWidth;
    const sWidth = ele.scrollWidth;
    const sLeft = ele.scrollLeft;
    if (oWidth - sWidth !== 0 && sLeft === 0) {
      console.log(sLeft);
      $(ele).next().addClass('show');
    }
  });
  $('.scroll-icon-menu ul').on('scroll', function ulScroll() {
    const scrollLeftMax = this.scrollWidth - this.clientWidth;
    const scrollLeft = Math.ceil(this.scrollLeft);
    if (scrollLeft > 0) {
      $(this).prev().addClass('show');
      $(this).next().addClass('show');
    }
    if (scrollLeftMax - scrollLeft <= 1) {
      $(this).next().removeClass('show');
    }
    if (scrollLeft === 0) {
      $(this).prev().removeClass('show');
    }
  });
  // click arrow
  $('.scroll-icon-menu .arrow-next').click(function next() {
    const scrollWidth = $(this).prev().width();
    const scrollLeft = $(this).prev().scrollLeft();
    // console.log(scrollWidth);
    $(this).prev().animate({
      scrollLeft: scrollLeft + (scrollWidth / 2),
    });
  });
  $('.scroll-icon-menu .arrow-prev').click(function prev() {
    const scrollWidth = $(this).next().width();
    const scrollLeft = $(this).next().scrollLeft();
    // console.log(scrollWidth);
    $(this).next().animate({
      scrollLeft: scrollLeft - (scrollWidth / 2),
    });
  });
  $('.scroll-icon-menu .icon-list li').click(function () {
    let pos = $(this).position().left;
    const posWidth = $(this).width();
    const currentScroll = $(this).parent().scrollLeft();
    const divWidth = $(this).parent().width();
    pos = (pos + currentScroll) - (divWidth / 2) + (posWidth / 2) - 30;
    $(this).parent().animate({
      scrollLeft: pos,
    });
  });

  /* Gallery */
  swiperD = new Swiper('.gallery', {
    navigation: {
      nextEl: '.side-button-next.fix.gall',
      prevEl: '.side-button-prev.fix.gall',
    },
  });
  setTimeout(() => {
    $('.side-button-prev.fix.gall').addClass('swiper-button-disabled');
  }, 500);

  /* Videos */
  function videos() {
    const swiperE = new Swiper('#videos', {
      navigation: {
        nextEl: '.side-button-next.fix.video',
        prevEl: '.side-button-prev.fix.video',
      },
    });
    const windowSize = $(window).width();
    if (windowSize < 479) {
      swiperE.destroy(true);
    }
  }
  setTimeout(() => {
    $('.side-button-prev.fix.video').addClass('swiper-button-disabled');
  }, 500);

  $(window).on('load resize', () => {
    videos();
    inside2();
    inside3();
  });

  // Fullgage
  // eslint-disable-next-line new-cap
  myFullpage = new fullpage('#fullpage', {
    licenseKey: 'D1WK9-D9LLK-K4RSH-6TKJ9-KYALL',
    responsiveWidth: 768,
    paddingTop: '72px',
    anchors: [
      'banner',
      'eTNGA',
      'bZ-charge',
      'bZ-power',
      'bZ-looks',
      'bZ-inside',
      'bZ-show',
      'safety-active',
      'bZ-safety',
      'pgallery',
      'vgallery',
      'Footer',
    ],
    menu: '.side-menu',
    slidesNavigation: true,
    scrollOverflow: true,
  });

  // mobil menu
  $('.side-menu-btn').on('click', () => {
    $('.side-menu-btn').toggleClass('active');
    $('.mobile-item').slideToggle(300);
  });
  $('.mobile-item a').on('click', () => {
    $('.side-menu-btn').toggleClass('active');
    $('.mobile-item').slideToggle(300);
  });
});
